import React from 'react'
import './block-table.sass'

const getTableHeaders = (headers) => {
  return headers.map((item, i) => {
    return (
      <th scope="col" colSpan={`${item.colspan ? item.colspan : '1'}`} key={i}>{item.name}</th>
    )
  })
}

const getTableBodyRows = (row) => {
  return row.map((item, i) => {
    return (
      <td key={i}>{item}</td>
    )
  })
}

const getTableBody = (body) => {
  return body.map((row, i) => {
    return (
      <tr key={i}>
        {getTableBodyRows(row.row)}
      </tr>
    )
  })
}

const BlockTable = ({ data }) => {
  const table = data.table;

  return (
    <section className={`
      BlockTable
      ${data.classes? data.classes : 'container-fluid'}
    `}>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="table-primary">
            <tr>
              {getTableHeaders(table.thead)}
            </tr>
          </thead>
          <tbody>
            {getTableBody(table.tbody)}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default BlockTable
